var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioediting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.423,
    height: 25.43,
    viewBox: "0 0 18.423 25.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.99 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.99 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.892,8.755a.437.437,0,0,0-.443.009L21.608,11.12H14.717a.438.438,0,0,0-.438.438v8.1a.438.438,0,0,0,.438.438H21.6l3.836,2.557a.438.438,0,0,0,.682-.365V9.138A.439.439,0,0,0,25.892,8.755ZM15.155,12h6.138v7.226H15.155V12Zm10.084,9.476L22.17,19.426V11.8l3.069-1.882ZM29.413,6.946a.438.438,0,0,0-.185-.358l-3.46-3.459,0,0a.441.441,0,0,0-.123-.083c-.013-.006-.027-.009-.04-.014a.44.44,0,0,0-.119-.024C25.475,3,25.468,3,25.459,3H11.428a.438.438,0,0,0-.438.438V27.991a.438.438,0,0,0,.438.438H28.966a.438.438,0,0,0,.438-.438v-21C29.406,6.974,29.413,6.961,29.413,6.946ZM25.9,4.5l2.011,2.011H25.9ZM11.867,27.553V3.877H25.02V6.946a.438.438,0,0,0,.438.438h3.069V27.553Z",
    transform: "translate(-10.99 -3)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioediting);
export default __webpack_public_path__ + "static/media/audioediting.5878b1cc.svg";
export { ForwardRef as ReactComponent };